import { Axios } from 'utils/AxiosConfig'

export const getMembership = async (payload) => {
  const { data: response } = await Axios.get(`member/profile/subscription`, { params: payload })
  return response
}

export const getExpiredNotSuspendedSubscription = async (payload) => {
  const { data: response } = await Axios.get(`member/profile/subscription/expired-not-suspended`, {
    params: payload
  })
  return response
}